import _ from './loader.module.scss'
import React from 'react'
import {$, $$$} from '../shared/class-name'
import {isAppRoute} from '../shared/app-routes'
import {useLocation} from 'react-router-dom'
import {TriSpinner} from './tri-spinner'

export const Loader = ({upfront, active, color='light'}) => {
    const {pathname} = useLocation()
    const appRoute = isAppRoute(pathname)
    return <div className={$$$(
        $(_.loader),
        $(_.upfront, upfront),
        $(_.bright, !appRoute),
        $(_.active, active),
        $(_.app, appRoute)
    )}>{appRoute && <TriSpinner color={color} elevated noTrack/>}</div>
}
